module.exports = __webpack_public_path__ + "img/rightcalf-mesomorph-female.dbfc26de.svg";